import { Button, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalOverlay } from '@chakra-ui/react'
import { Title } from "../../Atoms/";
import React from 'react'

const BatterySwappingModal = ({ show, hide, battery, newBattery, newBatteryOnChange, modalError, onSubmit }) => {
  return (
    <Modal isOpen={show} onClose={() => hide(false)} isCentered size={"xl"}>
      <ModalOverlay />

      <ModalContent className="modal-content">
        <ModalCloseButton />
        <ModalBody className="modal-body">
          <Title>Swap this battery</Title>
          <label className="current-battery">
            Current battery UID
            <Input disabled value={battery} />
          </label>
          <label className="new-battery">
            New Battery UID
            <Input value={newBattery} onChange={(e) => newBatteryOnChange(e.target.value)}  />
          </label>
        </ModalBody>

        <ModalFooter className="modal-footer">
          <p className='swap-battery-error'>{modalError}</p>
          <Button onClick={onSubmit} className='submit-battery-swap'>Swap Battery</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default BatterySwappingModal
